<ng-template let-extraClass="extraClass" #topNav>
  @if (isMobileResolution) {
    <tidy-top-nav
      [class]="extraClass"
      [title]="pageTitle"
      [canGoBack]="true" />
  }
</ng-template>

<ng-container
*ngTemplateOutlet="topNav;context:{ extraClass: 'mobile' }" />

<ng-template #content>
  <tidy-wrapper>
    <ng-container
    *ngTemplateOutlet="topNav;context:{ extraClass: 'desktop' }" />

    @if (!number && !isLoading) {
      @if (isGuestAccount) {
        <tidy-alert>
          <tidy-row>
            <tidy-text
              [body]="'Please complete your account signup to create a smart number.'" />
          </tidy-row>
          <tidy-row class="extra-top-padding">
            <tidy-button
              [text]="'Complete Signup'"
              class="primary"
              (click)="openCompleteSignup()" />
          </tidy-row>
        </tidy-alert>
      } @else if (!hasValidCard) {
        <tidy-alert>
          <tidy-row>
            <tidy-text
              [body]="'Please add a credit card to create a smart number.'" />
          </tidy-row>
          <tidy-row class="extra-top-padding">
            <tidy-button
              [text]="'Add Payment Method'"
              class="primary"
              (click)="goToAddPaymentMethod()" />
          </tidy-row>
        </tidy-alert>
      } @else {
        <tidy-button
          [text]="pageTitle"
          class="primary full-width"
          (click)="createProxyNumber()" />
      }
    }
    @if (number) {
      <div class="proxy-copy-row">
        <div>
          <tidy-text class="proxy-number" [header]="number" />
        </div>
        <div>
          <img
            class="proxy-copy-icon"
            src="assets/icon/copy-circle-black.svg"
            (click)="copyToClipboard(number)" />
        </div>
      </div>
    }

    @if (number) {
      <form [formGroup]="form" novalidate action="#">
        <tidy-row class="extra-bottom-padding vertical-align-center">
          <tidy-checkbox
            style="margin-right: 5px"
            formControlName="enableAI"
            [form]="form.controls.enableAI"
            [items]="[{viewValue: '', value: true}]" />
          <tidy-text
            [body]="'AI Suggested Actions (Beta)'" />
        </tidy-row>
      </form>
    }

    @if (numberType === 'guest') {
      <tidy-row class="extra-top-padding">
        <tidy-text [header]="'How Guest Number\'s Work'" />
      </tidy-row>
      <tidy-row>
        <tidy-text
          [body]="'1. Share this with guests, tenants, or anyone you want to be able message in.'" />
      </tidy-row>
      <tidy-row>
        <tidy-text
          [body]="'2. As guests message in, they come into your Messages section.'" />
      </tidy-row>
    }
    @if (numberType === 'pro') {
      <tidy-row class="extra-top-padding">
        <tidy-text [header]="'How Pro Number\'s Work'" />
      </tidy-row>
      <tidy-row>
        <tidy-text
          [body]="'1. Share this with pros who you want to be able to message in.'" />
      </tidy-row>
      <tidy-row>
        <tidy-text
          [body]="'2. As pros message in, they come into your Messages section.'" />
      </tidy-row>
    }

    <tidy-row style="padding-top: 1rem">
      <tidy-text [header]="'Optional'" />
    </tidy-row>
    <tidy-row>
      <tidy-text
        [body]="'1. Set up workflows to make inbound messages create Concierge Actions.'" />
    </tidy-row>
    <tidy-row>
      <tidy-text
        [body]="'2. Our team will create and update issues and jobs according to your preferences.'" />
    </tidy-row>

  </tidy-wrapper>
</ng-template>

@if (isMobileResolution) {
  <app-scroll-wrapper [templateContent]="content" />
}

@if (!isMobileResolution) {
  <ng-container *ngTemplateOutlet="content" />
}
